// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2aMQG","left":"InfoRow_left__18-oJ"};